var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMenuExpandableOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.08,
    height: 9.814,
    viewBox: "0 0 16.08 9.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8095",
    "data-name": "Path 8095",
    d: "M-9351.2-41.944l6.258,6.278,6.285-6.278",
    transform: "translate(9352.972 43.712)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuExpandableOpen);
export default __webpack_public_path__ + "static/media/mobile-menu-expandable-open.7540f2d401daf9eeebf9265c10906b7d.svg";
export { ForwardRef as ReactComponent };